export default class ObjectVisitorSegmentApiModel {
  constructor(rawModel) {
    this.ClassificationCode = rawModel?.ClassificationCode || null
    this.SegmentCode = rawModel?.SegmentCode || null
    this.SegmentName = rawModel?.SegmentName || rawModel?.NamePlural || null
    this.PriceOffset = rawModel?.PriceOffset || null
  }
}
